import axios from 'axios';
import React, { useEffect,useState } from 'react'

export default function RemainingIds() {
    const [remainingIds, setRemainingIds] = useState([])

    const fetchRemainingIds = async () => {
        try {
            const response = await axios.get('https://klimkaara-backend-pgnq.onrender.com/clients/getRemainingIds');
            setRemainingIds(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchRemainingIds()
    },[])
  return (
    <div className='min-h-screen'>
        <div className='text-3xl font-bold text-left my-8 mx-8'>
            Remaining Ids
        </div>
        <div className='flex items-center justify-center'>
            <table className='min-w-1/2 bg-gray-800 text-white rounded-lg shadow-lg'>
                <thead>
                    <tr className='bg-gray-200 text-black'>
                        <th className='px-4 py-2'>S No.</th>
                        <th className='px-4 py-2'>Remaining Ids</th>
                    </tr>
                </thead>
                <tbody>
                    {remainingIds.map((id, index) => (
                        <tr key={index} className='border-b'>
                            <td className='px-4 py-2'>{index + 1}</td>
                            <td className='px-4 py-2'>{id}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
  )
}
